import SuspenseLoader, { spinnerLoadingElement } from './SuspenseLoader';

export const defaultFallback = spinnerLoadingElement;
export default SuspenseLoader;
